import { render, staticRenderFns } from "./imprimepedidopix.vue?vue&type=template&id=1bb1002c&scoped=true"
import script from "./imprimepedidopix.vue?vue&type=script&lang=js"
export * from "./imprimepedidopix.vue?vue&type=script&lang=js"
import style0 from "./imprimepedidopix.vue?vue&type=style&index=0&id=1bb1002c&prod&scoped=scss&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb1002c",
  null
  
)

export default component.exports